<template>
	<div class="lds-ellipsis" :class="componentClass">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</template>

<script>
export default {
	name: 'LoadingAnimation',
	props: {
		componentClass: {
			type: String,
			default: 'centered colored',
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/utils/commons/LoadingAnimation.vue